import {
  SharedWithMeSpaceStateProps,
  SharedWithMeSpaceDispatchProps,
  SharedWithMeSpaceOwnProps,
  SharedWithMeSpaceAngularProps,
  SharedWithMeSpace
} from './SharedWithMeSpace';
import { AppState } from '../../state/AppState';
import { MapStateToProps, MapDispatchToProps } from '../../utils/ConnectUtils';
import { selectCurrentlyApplicableContentTypes, selectDefaultContentTypeFilterValues } from '../../selectors/ContentFilterSelectors';
import { siteUrlsSelector } from '../../selectors/SiteUrlsSelectors';
import { showContentTypes } from '../../actions/spaces/ContentExplorerFilterActions';
import { requestSpaceContents } from '../../actions/spaces/RequestSpaceContentsActions';
import { clearSpaceContentCountsAction } from '../../actions/spaces/ContentCountsActions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { errorBoundary, sendTelemetryErrorEvent } from '../../../common/react/components/ErrorBoundary';

const mapStateToProps: MapStateToProps<SharedWithMeSpaceStateProps> = (state: AppState) => ({
  contentTypeFilterValues: selectCurrentlyApplicableContentTypes(state),
  defaultContentTypeFilterValues: selectDefaultContentTypeFilterValues(state),
  urls: siteUrlsSelector(state)
});

const mapDispatchToProps: MapDispatchToProps<SharedWithMeSpaceDispatchProps> = (dispatch) =>
  bindActionCreators({
    filterSelected: showContentTypes,
    requestSpaceContents,
    clearContentCounts: clearSpaceContentCountsAction
  }, dispatch);

const ConnectedSharedWithMeSpaceInternal: React.ComponentClass<
  SharedWithMeSpaceOwnProps & SharedWithMeSpaceAngularProps>
  = connect(mapStateToProps, mapDispatchToProps)(SharedWithMeSpace);

export const ConnectedSharedWithMeSpace =
  errorBoundary<SharedWithMeSpaceOwnProps & SharedWithMeSpaceAngularProps>
    (sendTelemetryErrorEvent)(ConnectedSharedWithMeSpaceInternal);
